import script from "./Profile.vue?vue&type=script&setup=true&lang=js"
export * from "./Profile.vue?vue&type=script&setup=true&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=7d1322a4&lang=scss&scoped=true"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d1322a4"]])

export default __exports__